import { render, staticRenderFns } from "./supplier.vue?vue&type=template&id=6bd64ca9&"
import script from "./supplier.vue?vue&type=script&lang=js&"
export * from "./supplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bd64ca9')) {
      api.createRecord('6bd64ca9', component.options)
    } else {
      api.reload('6bd64ca9', component.options)
    }
    module.hot.accept("./supplier.vue?vue&type=template&id=6bd64ca9&", function () {
      api.rerender('6bd64ca9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/supplier/supplier.vue"
export default component.exports